import { Container } from '@mui/material';
import Page from '../../../components/Page';
import LocationManagementForm from './LocationManagementForm';

const index = () => {
  return (
    <Page title={'Location Management'}>
      <Container maxWidth={'xl'}>
        <LocationManagementForm />
      </Container>
    </Page>
  );
};

export default index;
